import type { Locale } from '@/i18n/types'

const RailsRoutes = {
  signIn: '/[locale]/users/sign_in?return_to',
  signOut: '/[locale]/users/sign_out',
  userProfile: '/[locale]/users/[id]',
  organisationDashboard: '/[locale]/manage/organisations/[slug]/dashboard',
  userDonationOverview: '/[locale]/t/user/donation_overview',
  askForDonationOverviewToken: '/[locale]/donation_overview_token/new',
  startNewProject: '/[locale]/projects/new?tracking_via',
  startNewFunE: '/[locale]/fundraising-events/registration/preselection?tracking_via',
  imprint: '/c/contact',
  donateToBetterplace: '/[locale]/projects/7046-spende-fuer-betterplace-org-damit-wir-gemeinsam-gutes-tun-koennen',
  fundraisingEventEdit: '/[locale]/fundraising-events/[slug]/manage/details/edit',
  aboutUs: (locale: Locale) => (locale === 'de' ? '/c/ueber-uns' : '/c/about-us'),
  aboutUsAcademy: '/c/ueber-uns/betterplace-academy?utm_source&utm_medium&utm_campaign',
  contactUs: (locale: Locale) => (locale === 'de' ? '/c/kontakt' : '/c/contact'),
  discovery: '/[locale]/discover?q',
  collect: (locale: Locale) => (locale === 'de' ? '/c/spenden-sammeln' : '/c/collect-donations'),
  blog: (locale: Locale) => (locale === 'de' ? '/c/neues' : '/c/news'),
  collectAsContentCreator: '/c/spenden-sammeln/creators4charity',
  donationGift: '/c/neues/spendengeschenk',
  collectAsPrivatePersonFundraising: (locale: Locale) =>
    locale === 'de' ? '/c/spenden-sammeln/privater-spendenaufruf' : '/c/collect-donations/private-fundraising',
  collectAsPrivatePersonAction: (locale: Locale) =>
    locale === 'de' ? '/c/spenden-sammeln/private-spendenaktion' : '/c/collect-donations/as-private-person',
  itz: '/c/ueber-uns/initiative-transparente-zivilgesellschaft',
  jobs: (locale: Locale) => (locale === 'de' ? '/c/stellen' : '/c/jobs'),
  legal: (locale: Locale) => (locale === 'de' ? '/c/regeln' : '/c/rules'),
  partnerPlatforms: '/c/hilfe/themen/partnerplattformen',
  popularProjects: '/[locale]/discover/44',
  press: '/c/medien',
  collectAsCompany: (locale: Locale) =>
    locale === 'de' ? '/c/spenden-sammeln/als-unternehmen' : '/c/collect-donations/as-company',
  collectAsStreamer: '/c/spenden-sammeln/charity-stream',
  collectAsOrganisation: (locale: Locale) =>
    locale === 'de' ? '/c/spenden-sammeln/als-verein' : '/c/collect-donations/as-non-profit',
  taxReceiptHintLink: '/c/hilfe/meine-spendenbescheinigung',
  team: (locale: Locale) => (locale === 'de' ? '/c/unser-team' : '/c/our-team'),
  message: '/[locale]/messages/new?recipient',
  projectPage: '/[locale]/projects/[id]',
} as const

export default RailsRoutes
